import { DateTime } from 'luxon';

export const useDate = (date?: string): string => {
  if (date) {
    const dt = DateTime.fromISO(date);
    return dt.toLocaleString(DateTime.DATE_SHORT);
  }
  return '';
};
